import React, { useContext } from "react";
import { Box, Typography, Button, Card, CardContent, Grid } from "@mui/material";
import { AuthContext } from "../../context/AuthContext";
import { useNavigate } from "react-router-dom";
import "./SuspendedUserPage.css";
import Header from "../../components/Header/Header";

const navLinks = [];

const SuspendedUserPage = () => {
  const { role } = useContext(AuthContext); // User role (e.g., 'student', 'school', etc.)
  const navigate = useNavigate();

  const handleSubscriptionClick = () => {
    navigate("/subscription");
  };

  const handleContactSchoolClick = () => {
    navigate("/contact");
  };

  return (
    <>
        <Header navLinks={navLinks} isScrollEffect={false} />
        <Box className="suspended-page">
        <Card className="suspended-card">
            <CardContent>
            <Typography variant="h4" className="suspended-title">
                Account Suspended
            </Typography>
            <Typography variant="body1" className="suspended-message">
                Your account has been suspended. Let's figure out how to resolve this.
            </Typography>
            <Grid container spacing={3} justifyContent="center" mt={2}>
                {/* Role-Specific Actions */}
                
                <Grid item xs={12} md={6}>
                    <Box className="message-box">
                    <Typography variant="h6" className="suspended-role-text">
                        Part of a school?
                    </Typography>
                    <Typography className="suspended-role-message">
                        Contact your school administrator for assistance regarding your account status.
                    </Typography>
                    <Button
                        variant="contained"
                        className="contact-school-button"
                        onClick={handleContactSchoolClick}
                    >
                        Contact your school
                    </Button>
                    </Box>
                </Grid>
              
                <Grid item xs={12} md={6}>
                    <Box className="message-box">
                    <Typography variant="h6" className="suspended-role-text">
                        Not part of a school?
                    </Typography>
                    <Typography className="suspended-role-message">
                        Check your subscription status in your profile page. Your subscription plan may need renewal.
                    </Typography>
                    <Button
                        variant="contained"
                        className="renew-subscription-button"
                        onClick={handleSubscriptionClick}
                    >
                        Check Subscription
                    </Button>
                    </Box>
                </Grid>
                
            </Grid>
            </CardContent>
        </Card>
        </Box>
    </>
  );
};

export default SuspendedUserPage;
